import { CompanyFormState } from "~/types/data/Company.types";

export const companyFormStateInitState: CompanyFormState = {
  // uboDeclarationStatus: UboStatusEnum.CREATED,
};
